import { AddOn } from './AddOn'
//import * as wording from '../../../common/js/wording'
import { AddOnType, Operator, Bandwidth } from '../FbbEnum'
import * as log from '../../../common/js/appLogger'


/*
20250820 - mandatory VAS.
*/
export class AddOnMandatory extends AddOn{

    private contentJson:any = {} //from json file
    private codeInfo: any = {} //from get plan api

    constructor(){
        super()
        this.key = 'AddOnMandatory'
        
        this.boxIconEn = ''
        this.boxIconZh = ''
        this.boxNameEn = 'AddOnMandatory'
        this.boxNameZh = 'AddOnMandatory'
        this.boxAmount = 0
        this.hasRedCounter = false
        
        this.type = AddOnType.SINGLE
        
    }

    public isAddOnSelected() : boolean{
        return true
    }

    public setAddonJson(json: any) {
        this.contentJson = json
    }

    public setCodeInfo(codeInfo:any) {
        this.codeInfo = codeInfo
    }

    public getGAJson() : any{
        return this.contentJson?.GA ?? {}
    }

    public getBoxIcon(lang: string) : any {
        return (this.contentJson?.details?.icon ?? {})[lang] ?? ''
    }
    
    public getPromptHtmlTitle(lang: string) : ''{
        return (this.contentJson?.details?.promptHtmlTitle ?? {})[lang] ?? ''
    }

    public getPromptHtmlDesc(lang: string) : ''{
        return (this.contentJson?.details?.promptHtmlDesc ?? {})[lang] ?? ''
    }

    public getTitle1(lang: string) : ''{
        return (this.contentJson?.details?.title1 ?? {})[lang] ?? ''
    }

    public getSubtitle1(lang: string) : ''{
        return (this.contentJson?.details?.subtitle1 ?? {})[lang] ?? ''
    }

    public getTitle2(lang: string) : ''{
        return (this.contentJson?.details?.title2 ?? {})[lang] ?? ''
    }

    public getSubtitle2(lang: string) : ''{
        return (this.contentJson?.details?.subtitle2 ?? {})[lang] ?? ''
    }

    public createGAItem(lang: string, contractPeriod: string, operator:Operator, bandwidth: Bandwidth) : any{
        
        log.dt('createGAItem', 'bandwidth: ' + bandwidth)
        var main = {
            "item_id": this.getGAJson()['item_id'],
            "item_name": this.getGAJson()['item_name_' + lang],
            "currency": "HKD",
            "item_brand": this.getGAJson()['item_brand'],
            "item_category": "Services",
            "item_list_id": "fbb",
            "item_list_name": "FBB Portal",
            "price": 0,
            "quantity": 1,
        }
        return main
    }


}